import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import GuestPortal from "@/pages/GuestPortal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BookNow from "@/pages/BookNow";
import LobbyKiosk from "@/pages/LobbyKiosk";
import RoomService from "@/pages/RoomService";
import QRCodeGenerator from "@/pages/QRCodeGenerator";
import LobbySignQR from "@/pages/LobbySignQR";
import DemoPortal from "@/pages/DemoPortal";
import DemoAdmin from "@/pages/DemoAdmin";
import Documentation from "@/pages/Documentation";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <HashRouter>
          <Routes>
            <Route path="/" element={<GuestPortal />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/docs"
              element={
                <ProtectedRoute>
                  <Documentation />
                </ProtectedRoute>
              }
            />
            <Route path="/book" element={<BookNow />} />
            <Route path="/lobby" element={<LobbyKiosk />} />
            <Route path="/room" element={<RoomService />} />
            <Route path="/qrcodes" element={<QRCodeGenerator />} />
            <Route path="/lobby-sign" element={<LobbySignQR />} />
            <Route path="/demo" element={<DemoPortal />} />
            <Route path="/demo/admin" element={<DemoAdmin />} />
          </Routes>
        </HashRouter>
        <Toaster position="top-right" richColors />
        <div className="noise-overlay" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
